<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="close">
    <div class="modal">
      <div class="modal-header">
        <h3>Soutenir le développeur</h3>
        <button class="btn-close" @click="close"><i class="fa-solid fa-xmark" /></button>
      </div>
      <p class="support-text">
        Cet outil est gratuit et développé bénévolement, sur mon temps libre.
        Si vous souhaitez contribuer aux frais d'hébergement, c'est libre et sans contrepartie.
      </p>
      <div class="support-actions">
        <a href="https://liberapay.com/elpulpo/donate" target="_blank" rel="noopener"
          class="btn-support btn-support-recurring">
          💛 Don récurrent : Liberapay
        </a>
        <a href="https://paypal.me/elpulpo" target="_blank" rel="noopener" class="btn-support btn-support-once">
          ☕ Don ponctuel : PayPal
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isOpen = ref(false)

const open = () => { isOpen.value = true }
const close = () => { isOpen.value = false }

onMounted(() => {
  window.addEventListener('open-support-modal', open)
})

onBeforeUnmount(() => {
  window.removeEventListener('open-support-modal', open)
})
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  z-index: 2000;
}

.modal {
  background: var(--bg-card);
  border-radius: var(--radius);
  padding: 1.5rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-header h3 {
  margin: 0;
}

.btn-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: var(--text-muted);
}

.support-text {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
}

.support-actions {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.btn-support {
  display: block;
  text-align: center;
  padding: 0.6rem 1rem;
  border-radius: var(--radius);
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.15s;
}

.btn-support:hover {
  opacity: 0.85;
}

.btn-support-recurring {
  background: #eab308;
  color: #1e293b;
}

.btn-support-once {
  background: #0070ba;
  color: white;
}
</style>
